import type { TargetStatus } from '../../../types/collection-targets'

export const BULK_TARGET_STATUSES: TargetStatus[] = [
  'pending',
  'in_progress',
  'collecting',
  'collected',
  'partial',
  'failed',
  'client_halted',
  'cancelled',
  'ingested',
]

export function statusDisplayLabel(status: string): string {
  return status
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}
